module.exports = __webpack_public_path__ + "img/hamburguesa doble carne.6ae7c35a.jpeg";